import React from 'react';
import { generatePath } from 'react-router-dom';
import { useDataVendor } from 'v2/queries/useDataVendor';
import { getDataVendorAvatarURL } from 'v2/utils';
import { LinkCreatedBodyProps } from '../../types';
import { LinkEntityBody } from '../LinkEntityBody';

export function DataVendorLinkCreatedBody({
  relationship,
}: LinkCreatedBodyProps) {
  const { data: dataVendor, isLoading: isDataVendorLoading } = useDataVendor({
    id: relationship.object_id,
  });

  if (isDataVendorLoading || !dataVendor) return null;

  const avatarURL = getDataVendorAvatarURL(dataVendor);
  const path = '/data-provider-details/:id/detail';

  return (
    <LinkEntityBody
      avatar={avatarURL}
      title={{
        text: dataVendor?.name,
        url: generatePath(path, {
          id: dataVendor.id,
        }),
      }}
      subtitle={dataVendor?.classification}
    />
  );
}
